import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { markdownToText } from "../../../utils/markdownToText";
import { clearChatHistory } from "./ClearChatHistory";
import { SessionManager } from "../../../utils";

// Async thunk — fetch chat history list
export const fetchHistory = createAsyncThunk('fetchHistory', async () => {
    try {
        const res = await axios.get(process.env.REACT_APP_CHAT_URL + 'history', {
            headers: {
                'Content-Type': 'application/json',
                Authorization: SessionManager.getSession("user_token"),
            },
        });

        // return the data directly for simpler handling
        return res;
    } catch (error) {
        return error.response;
    }
});

const fetchHistorySlice = createSlice({
    name: "fetchHistory",
    initialState: {
        messages: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch history cases
            .addCase(fetchHistory.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchHistory.fulfilled, (state, action) => {
                state.isLoading = false;
                state.error = null;

                const body = action.payload?.data;

                // Handle the specific history format
                if (body && body.history && Array.isArray(body.history)) {
                    const normalized = body.history.flatMap(item => [
                        {
                            type: 'user',
                            message: item.query || '',
                            timestamp: item.timestamp || new Date().toISOString()
                        },
                        {
                            type: 'bot',
                            message: markdownToText(item.answer) || '',
                            timestamp: item.timestamp || new Date().toISOString()
                        }
                    ]);

                    state.messages = normalized;
                } else {
                    state.messages = [];
                }
            })
            .addCase(fetchHistory.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload?.message || action.error?.message || 'Failed to fetch chat history.';
            })
            // Listen to clearChatHistory to clear messages
            .addCase(clearChatHistory.fulfilled, (state) => {
                state.messages = [];
            });
    },
});

export default fetchHistorySlice.reducer;

